export default "__VITE_ASSET__CYuUh8dc__"